import Vue from "vue";
import flatPickr from "vue-flatpickr-component";

Vue.component("flat-pickr", flatPickr);
